module.exports = __webpack_public_path__ + "static/media/me.f366d1ff.jpg";